import { Component, inject } from '@angular/core';
import { Product } from '../product/product';
import { ProductService } from '../../service/product-service';
import { AsyncPipe } from '@angular/common';


@Component({
  selector: 'app-featured-products',
  imports: [Product, AsyncPipe],
  templateUrl: './featured-products.html',
  styleUrl: './featured-products.scss'
})
export class FeaturedProducts {
  private productService = inject(ProductService);

  featuredProducts$ = this.productService.getFeaturedProducts(10);
}
